<template>
  <div>
    <h4>國文科</h4>
    <dl>
      <dt>資優國文班</dt>
      <dd>
        資優國文班課程包含翰林、康軒、南一各版內容，公立、私立學校學生都適合上的國文課。使用高僑自編教材，作文、國學常識、字音字形、閱讀、文言文通通一網打盡！考試前會針對各校不同範圍做段考複習。
      </dd>

      <dt>菁英國文班 （需經甄試入班）</dt>
      <dd>
        菁英國文班為資優國文班加深加廣課程，課程範圍包含各版本內容，適合公立、私立學校學生參加，難度較深需經過甄試入班。考試前會針對各校不同範圍做段考複習。
      </dd>
    </dl>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/scss/course.scss";
</style>
